import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class StoreService {
  showSidePanelNotification: boolean = false;
  sidePanelNotificationMessage: string = 'Error.';
  sidePanelNotificationType: string = 'error';
  sidePanelNotificationIcon: string = 'exclamation-octagon';
  sidePanelNotificationFieldWithError: string = '';
  showNotification: boolean = false;
  notificationMessage: string = 'Notification';
  notificationType: string = 'success';
  notificationIcon: string = 'exclamation-circle';
  formValidToSubmitInternalValidations = true;
  errorMap: Map<string, string[]> = new Map<string, string[]>();

  public triggerNotification(message?: string, type?: string, icon?: string) {
    if (message) this.notificationMessage = message;
    if (type) this.notificationType = type;
    if (icon) this.notificationIcon = icon;
    this.showNotification = true;
    setTimeout(() => {
      this.showNotification = false;
    }, 3000);
  }

  public triggerSidePanelNotification(
    message?: string,
    fieldWithError?: string,
    type?: string,
    icon?: string,
    errorMap?: Map<string, string[]>,
  ) {
    if (fieldWithError)
      this.sidePanelNotificationFieldWithError = fieldWithError;
    if (message) this.sidePanelNotificationMessage = message;
    if (type) this.sidePanelNotificationType = type;
    if (icon) this.sidePanelNotificationIcon = icon;
    if (errorMap) this.errorMap = errorMap;
    this.showSidePanelNotification = true;
  }
}
